/**
 * ADD IT — the desktop modal (docs/ADD-IT.md, spec 2026-09-04; the CALL IT
 * frame, `design/GT Mine.dc.html:419-437`, with two rows in place of the
 * strip).
 *
 * 460px. Header `ADD IT` + `WHERE DOES IT GO?`; the game's name; two rows —
 * `GAMES TONIGHT?` (the party's list, everyone sees it) and `MY BACKLOG`
 * (yours alone). Separate bordered cells, not a segmented pair. A row the game
 * is already on is a fact, not a button. Choosing closes the modal first, then
 * adds — so the party path's CALL IT never stacks on this.
 *
 * Built ahead of the mirror (Marcus, 2026-09-04) — when the design agent draws
 * theirs, this file follows the pulled bytes.
 */

import { DoorIcon } from '../../components/DoorIcon.tsx';
import { useQd } from '../../store/index.ts';
import { addItVM } from '../../store/selectors.ts';
import { Modal } from '../components/Modal.tsx';

const MONO = 'var(--gt-font-mono)';
const PIXEL = 'var(--gt-font-pixel)';

export default function AddItModal(): JSX.Element {
  const s = useQd();
  const v = addItVM(s);
  return (
    <Modal
      onClose={() => s.closeAdd()}
      width={460}
      label="Add it modal"
      header={{ title: 'ADD IT', titleClr: 'var(--gt-text)', titleFs: '10px', note: v.strap }}
    >
      <div style={{ padding: '16px 18px 6px', fontFamily: 'var(--gt-font-sans)', fontWeight: 600, fontSize: 16, color: 'var(--gt-text)' }}>{v.n}</div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8, padding: '8px 18px 18px' }}>
        {v.rows.map((r) => (
          <div
            key={r.key}
            onClick={() => {
              if (r.done) return;
              void (r.key === 'tonight' ? s.addToTonight() : s.addToBacklog());
            }}
            className={r.done ? undefined : 'd-hov-card'}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 12,
              height: 60,
              padding: '0 14px',
              border: '1px solid ' + (r.done ? 'var(--acc)' : 'var(--gt-border-2)'),
              background: r.done ? 'var(--accSoft)' : 'transparent',
              cursor: r.done ? 'default' : 'pointer',
              boxSizing: 'border-box',
            }}
          >
            <DoorIcon kind={r.icon} size={16} />
            <div style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', gap: 6 }}>
              <span style={{ fontFamily: PIXEL, fontSize: 8.5, color: r.done ? 'var(--acc)' : 'var(--gt-text)', display: 'flex', alignItems: 'center' }}>
                <span style={{ transform: 'translateY(0.13em)' }}>{r.l}</span>
              </span>
              <span style={{ fontFamily: MONO, fontSize: 8, letterSpacing: '.07em', color: 'var(--gt-muted)' }}>{r.gloss}</span>
            </div>
            <span style={{ fontFamily: MONO, fontSize: 9.5, letterSpacing: '.06em', color: r.done ? 'var(--acc)' : 'var(--gt-text)', whiteSpace: 'nowrap', flex: 'none' }}>
              {r.state}
            </span>
          </div>
        ))}
      </div>
    </Modal>
  );
}
